import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { MdDragIndicator } from 'react-icons/md';

import * as S from './styles';
import { color } from 'styles/pallete';

interface SortableItemProps {
	id: null | number | string;
	children: React.ReactNode;
	styleProps?: any;
	lockAxisX?: boolean; // se true não permite movimentação na horizontal
	colorIconDrag?: string;
	sizeIconDrag?: string;
	showBtnDrag?: boolean;
}

export function SortableItem({
	id,
	styleProps,
	children,
	lockAxisX = false,
	colorIconDrag = color.interface.lightGray,
	sizeIconDrag = '2rem',
	showBtnDrag = false
}: SortableItemProps) {
	const {
		attributes,
		listeners,
		setNodeRef,
		transform,
		transition,
		isDragging
	} = useSortable({ id: id || 0 });

	const style = {
		transform: CSS.Transform.toString(
			transform ? { ...transform, x: lockAxisX ? 0 : transform.x } : null
		),
		transition,
		zIndex: isDragging ? 999 : 'auto',
		position: isDragging ? 'relative' : 'static'
	};

	return (
		<S.item
			ref={setNodeRef}
			style={{ ...style, ...styleProps }}
			{...attributes}
			{...(!showBtnDrag ? listeners : {})} //caso não queira o btn drag, todo o item fica arrastavel
			data-id={id}
		>
			<S.handle $isDragging={isDragging} $showBtnDrag={showBtnDrag}>
				{showBtnDrag ? (
					<>
						<S.icon
							{...(showBtnDrag ? listeners : {})} //caso  queira o btn drag, somente o ICONE fica arrastavel
							$isDragging={isDragging}
							$colorSvg={colorIconDrag}
							$sizeIconDrag={sizeIconDrag}
						>
							<MdDragIndicator />
						</S.icon>
						{children}
					</>
				) : (
					<>{children}</>
				)}
			</S.handle>
		</S.item>
	);
}
